import { SCHEMA_CTX } from '../constants';

/**
 * Builds structured data for videos in JSON-LD format.
 * @param {Object} options - The options object.
 * @param {Array<Object>} options.videos - Array of video objects containing video metadata.
 * @param {string} options.productLabel - Label for the product name.
 * @returns {Object} JSON-LD structured data object with video information.
 */
export const getVideoStructuredData = ({ videos, productLabel } = {}) => {
  return {
    '@context': SCHEMA_CTX,
    '@graph': videos && videos.map(({
      thumbnail, videoStill, shortDescription, url, uploadDate, dateModified
    }) => ({
      '@type': 'VideoObject',
      name: productLabel,
      description: shortDescription,
      thumbnailUrl: [thumbnail || videoStill],
      contentUrl: url,
      uploadDate,
      dateModified,
    }))
  };
};
